"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var tfs_navigation_header_1 = __importDefault(require("tfs.navigation-header"));
var tfs_navigation_items_1 = __importDefault(require("tfs.navigation-items"));
var tfs_navigation_item_1 = __importDefault(require("tfs.navigation-item"));
var tfs_navigation_profile_1 = __importDefault(require("tfs.navigation-profile"));
var tfs_transavia_logo_t_1 = __importDefault(require("tfs.transavia-logo-t"));
var PartnerHeader = (function (_super) {
    __extends(PartnerHeader, _super);
    function PartnerHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.getActiveNavigation = _this.getActiveNavigation.bind(_this);
        _this.getLabel = _this.getLabel.bind(_this);
        var initialSelectedLink = _this.getActiveNavigation();
        _this.state = {
            selectedItem: initialSelectedLink,
            isOpen: initialSelectedLink.subNavigation.length ? true : false,
        };
        return _this;
    }
    PartnerHeader.prototype.currentURL = function () {
        return typeof window !== 'undefined' ? window.location.href.toLowerCase() : '';
    };
    PartnerHeader.prototype.getLabel = function (key) {
        var _a = this.props.labels, labels = _a === void 0 ? {} : _a;
        return labels[key] || key;
    };
    PartnerHeader.prototype.getActiveNavigation = function () {
        var _this = this;
        var navigationLinks = this.props.navigationLinks;
        if (!navigationLinks.length) {
            return { key: '', label: '', subNavigation: [] };
        }
        return (navigationLinks.find(function (navigationLink) {
            return navigationLink.subNavigation.find(function (navLink) {
                return _this.currentURL().includes(navLink.url.toLowerCase());
            });
        }) || navigationLinks[0]);
    };
    PartnerHeader.prototype.render = function () {
        var _this = this;
        var _a = this.state, isOpen = _a.isOpen, selectedItem = _a.selectedItem;
        var _b = this.props, navigationLinks = _b.navigationLinks, username = _b.username, logout = _b.logout, homeUrl = _b.homeUrl;
        if (!navigationLinks || !navigationLinks.length)
            return null;
        return (react_1.default.createElement(tfs_navigation_header_1.default, { isOpen: isOpen },
            react_1.default.createElement(tfs_transavia_logo_t_1.default, { gridRow: "1", gridColumn: "1", text: "partners", link: homeUrl }),
            react_1.default.createElement(tfs_navigation_items_1.default, { gridRow: "1", gridColumn: "2", gridColumnSpan: "2" }, navigationLinks.map(function (navigationItem, i) { return (react_1.default.createElement(tfs_navigation_item_1.default, { type: "main", key: i, active: String(selectedItem.key === navigationItem.key) },
                react_1.default.createElement("span", { "data-element": "navigation-item-" + i, onClick: function () {
                        return _this.setState({ selectedItem: navigationItem, isOpen: true });
                    } }, _this.getLabel(navigationItem.key)))); })),
            react_1.default.createElement(tfs_navigation_profile_1.default, { gridRow: "1", gridColumn: "3", gridColumnSpan: "1" },
                react_1.default.createElement(tfs_navigation_item_1.default, null, username),
                react_1.default.createElement(tfs_navigation_item_1.default, { onClick: function () { return logout(); }, "data-element": "log-out-button" }, this.getLabel('logout'))),
            react_1.default.createElement(tfs_navigation_items_1.default, { gridRow: "2", gridColumn: "2", gridColumnSpan: "2" }, selectedItem.subNavigation.map(function (x, i) { return (react_1.default.createElement(tfs_navigation_item_1.default, { type: "sub", key: i },
                react_1.default.createElement("a", { href: x.url }, _this.getLabel(x.label)))); }))));
    };
    return PartnerHeader;
}(react_1.Component));
exports.default = PartnerHeader;
//# sourceMappingURL=PartnerHeader.js.map